import WidgetInitializerPlugin from "auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPlugin";
import WidgetInitializerPluginDefinition from "auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPluginDefinition";
import IContainerInjection from 'auto-widget-framework/src/Container/IContainerInjection';
import Mixin from 'auto-widget-framework/src/Util/Mixin';

/**
 * Initializes customer widget config.
 */
export default class CustomerInitializer extends WidgetInitializerPlugin {

  constructor(definition, mappingValidator, customerTransformer) {
    super(definition);
    this.mappingValidator = mappingValidator;
    this.customerTransformer = customerTransformer;
  }

  static create(definition, container) {
    return new this(
      definition,
      container.get('mapping_validator'),
      container.get('transformer.customer_to_config')
    );
  }

  /**
   *
   * @param {PXWidgetConfig} config
   * @param state
   */
  initialize(config, state) {
    if (config.getCustomer()) {
      return new Promise((resolve) => {
        const customer = this.customerTransformer.from(config.getCustomer());
        this.mappingValidator.validate(customer, "Invalid customer object on widget configuration.");

        config.setCustomer(customer);
        resolve();
      });
    } else {
      return Promise.resolve();
    }
  }

}

export const CustomerInitializerDefinition = new WidgetInitializerPluginDefinition({
  id: "customer_initializer",
  class: CustomerInitializer,
  priority: 350
});

Mixin(CustomerInitializer, IContainerInjection);
